const utils = require('frontend-controller/lib/utils')

module.exports = {
	extends: [
		'/',
		'base',
		'tableSimple',
		'table'
	],

	config: {
		isSortable: true,
		lazyloadStepSize: 25,
		preventSortOfField: {
			tags: true,
		},
		buttonContext: 'prompt',
		renderEmptyBeforReady: false,
		showHead: false,
		showInsertButton: false,
		showColorCodedRows: true,
		showAllBorders: false,
		showDelimiterBorders: true,
		inline: true,
		maxNrOfExportElements: 500000,
		privilegeBase: 'mblx_prompts',
		rowActionsProperties: {
			colWidth: '43px',
		},
		rowActions: {
			delete: true,
		},
	},

	model: {
		resourceFilters: {
			order: [{
				fieldCode: 'promptID',
				direction: 'asc'
			}],
		},
		pickerFieldConfig: {}, // field config of templateAtom (promptPickerButton) if available.
	},

	methods: {

		dataDealer: function(){
			var self = this;
			if(!self.model.controller){
				self.closest('templates_mblx_prompts_controller', function(controller){
					self.model.controller = controller
				});
			}

			if(self.model.isInPicker){
				this.config.rowActions.delete = false
			}

			if(self.config.usage === 'selection' && !self.model.isInPicker){
				self.updateListOfIDs()
			}
		},

		updateListOfIDs: function(){
			if(!this.model.selectedRowIDInitialized){
				this.model.selectedRowIDInitialized = true;
				this.model.selectedRowIDs = utils.simpleCopy(this.getResourceRegisterContent('selectedRowIDs') || []);
				this.model.blackListedProductIDs = utils.simpleCopy(this.getResourceRegisterContent('blackListedProductIDs') || []);
			}
		},

		sanitizeEntity: function(refEntity){
			var self = this;
			if(self.config.usage === 'selection' && self.config.isSelectionSource){
				refEntity.selected = utils.indexOf(self.model.selectedRowIDs, refEntity.attributes[refEntity.primaryKey || 'id']) > -1;
			}
		},

		sanitizeResourceFilters: function(storage, resourceFilters, actionKey){

			if(actionKey === 'refreshResources'){
				var self = this;
				if(self.model.isInPicker === undefined){
					// IDEA: isn't there a better place to handle configs than here?
					self.model.isInPicker = false;
					self.closest('templates_mblx_prompts_picker_button', function(pickerButton){
						self.model.isInPicker = true;
						self.model.pickerFieldConfig = pickerButton.model.config || {};
						self.config.isMultiSelect = !!self.model.pickerFieldConfig.isMultiSelect;
						self.model.selectedRowIDs = pickerButton.model.dataJSON || [];
					});
				}

				resourceFilters = resourceFilters || {};
				resourceFilters.baseFilters = resourceFilters.baseFilters || {};

				// initialize selectedRows and other id lists if necessary.
				// this may be the case if the components resources are dependent on these ids.
				// e.g., subProductPicker-selectionTarget-table which has to load the products previously picked according to the given productID-Selection.
				// the dataDealer would usually handle such cases but resourceFilters may be needed long before the dataDealer is called.
				if(this.config.isSelectionSource || this.config.isSelectionTarget){
					this.updateListOfIDs()
				}

				if(this.config.isSelectionSource){
					if(utils.collectionSize(this.model.blackListedProductIDs) > 0){
						resourceFilters.baseFilters.blackListedProductIDs = this.model.blackListedProductIDs;
					} else {
						resourceFilters.baseFilters.blackListedProductIDs = [];
					}

					if((resourceFilters.filters || {}).selectedOnly){
						resourceFilters.filters.listOfPrimaryKeys = Object.values(this.getSelectedRowIDs(true) || {}) || []
					} else {
						delete resourceFilters.filters.listOfPrimaryKeys
					}
				}

				resourceFilters.filters = resourceFilters.filters || {};
			}
			return resourceFilters;
		},

		loadResourcesGranted: function(storage, resourceFilters, actionKey, fieldCode, attachTriggerOptions){
			var nrOfFilters = utils.collectionSize((resourceFilters || {}).filters)
			return actionKey !== 'refreshResources' || nrOfFilters > 1 || (nrOfFilters > 0 && resourceFilters.tags_tagConnection === undefined);
		},

		addEntity: function(entity){
			// add entity to dom if possible
			if(this.config.isReady && (this.model.$table || []).length > 0){
				this.model.$table.append(this.include('./row', { config: this.config, resourceData: entity, model: this.model }));
			}
		},

		showInsert: function(){
			const baseActionKey = 'showInsert_prompt';
			return this.performAndStoreAction(
				baseActionKey + '_inEffect',
				this.prepareAction(baseActionKey),
				true
			)
		},

		showEdit: function(rowID, rowData, buttonMode){
			if (rowID) {
				if(this.config.usage === 'selection'){
					if(this.config.isSelectionSource && this.model.controller){
						this.model.controller.toggleRowSelection(rowID, rowData);
					}
				} else {
					return this.performAndStoreAction(
						'showEdit_prompt_inEffect',
						this.prepareAction(
							'showEdit_prompt',
							rowID,
						),
						true
					)
				}
			}
		},

		async delete(rowID, rowData, buttonMode){

			if(!rowID){
				console.error('MISSING ROW_ID')
				return false
			}

			const context = await this.performDecision(
				'confirm',
				{
					component:  this,
					title:      storage.__('hint.delete.really.mblx.prompt.title'),
					message:    storage.__('hint.delete.really.mblx.prompt.message')
				}
			)

			if (context.decision.type !== 'yes') {
				return false
			}

			await this.performAction(
				this.prepareAction('delete_prompt', rowID)
			)

			await this.refreshData(true)
		},

		sourceSelectionChanged: function(){
			if(this.model.isInPicker && this.config.isSelectionSource){
				this.triggerClosest('onTableSelectionChanged', { selectedRowIDs: this.getSelectedRowIDs(true) })
			}
		},

		selectionChanged: function(){
			if(this.model.isInPicker){
				this.triggerClosest('onChildChanged', {
					value: this.getSelectedRowIDs()
				});
			}
		},

		customClickHandler: function(event){
			var bubble = $(event.target).closest('.bubble')
			var tagsColumn = $(event.target).closest('.fieldOf_tags')
			if(bubble.length > 0 && tagsColumn.length > 0){
				var tagKey = bubble.data('tagKey');
				var tagParts = String(tagKey || '').split('_') || [];
				var categoryID = tagParts[0] || 0
				var categoryDataID = tagParts[1] || 0
				if(categoryID && categoryDataID){
					this.triggerClosest('colTagsBubbleSelected', {
						categoryID,
						categoryDataID
					}, 'templates_mblx_prompts_controller')
					return true;
				}
			}

			return false;
		},

		onAfterLazyLoad: function(errorOccurred){
			if(!errorOccurred){
				this.updateBubbleHighlighting()
			}
		},

		updateBubbleHighlighting: function(){
			var highlightTagBubbles = ((this.model.resourceFilters || {}).filters || {}).tags || [];
			this.$.find('.fieldOf_tags .bubble').removeClass('highlighted');
			if(highlightTagBubbles.length > 0){
				this.$.find(highlightTagBubbles.map(tagKey => `.fieldOf_tags .bubble[data-tag-key="${tagKey}"]`).join(',')).addClass('highlighted');
			}
		},
	},

	hooks: {
		_attach: function($element, options){
			this.updateBubbleHighlighting()
		},

		async onDecision($element, options){
			const modal = options.decisionComponent
			if(!modal || !modal.hasClass('base_modal_modal')){
				return
			}

			if(options.decisionType === 'cancel'){
				return modal.hide()
			}

			if(modal.hasClass('container_templates_mblx_prompts_propertiesForm')){
				let propertiesForm
				modal.find('templates_mblx_prompts_propertiesForm', c => propertiesForm = c)
				if(propertiesForm){
					await propertiesForm.submit()
					await modal.hide()
					this.refreshData(true)
				}
			}
		},

		toggleRowSelection: function($element, options){
			this.toggleRowSelection(options.rowID, options.rowData);
		}
	},
}